<template>
<div class="h-school-list-wrapper">
    <div class="s-search-head-common-wrapper clearfix">
        <i class="wl-icon-xiangzuo fl" @click="toBack"></i>
        <van-search shape="round" class="search-input-con fr" placeholder="请输入学校名称" v-model="schoolNameVal" @input="searchBtn" @search="searchBtn" @blur="searchBtn"></van-search>
    </div>
    <van-index-bar :index-list="indexList" :z-index="100">
        <div v-for="(item,idx) in schoolList" :key="idx">
            <van-index-anchor :index="item.GroupName">{{item.GroupName}}</van-index-anchor>
            <ul>
                <li class="school-name-li-con van-hairline--bottom" v-for="(citem,i) in item.Infos" :key="i">
                    <div class="school-name-li clearfix" @click="selectSchool(citem.Id,citem.SchoolName)">
                        <div class="fl select-school-radio" :class="{'activeIndex' : activeVal == citem.Id}"></div>
                        <div class="fl sc-name-val van-ellipsis">{{citem.SchoolName}}</div>
                    </div>
                </li>
            </ul>
        </div>
    </van-index-bar>
    <div class="sure-select-btn" @click="sureSelect">确认选择</div>
</div>
</template>

<script>
export default {
    data() {
        return {
            indexList: [],
            schoolList: [],
            schoolVal: "",
            schoolName: "",
            schoolNameVal: '',
            activeVal: ''
        };
    },
    props: {
        type: {
            type: String,
            default: ''
        }
    },
    created() {
        this.testWXData();
    },
    methods: {
        toBack() {
            this.$router.go(-1);
        },
        selectSchool(id, name) {
            this.schoolVal = id;
            this.activeVal = id;
            this.schoolName = name;
        },
        searchBtn() {
            this.testWXData();
        },
        testWXData() {
            this.$http.post("/api/XOrg/XLogin/GetSchoolListByWord", {
                SchoolName: this.schoolNameVal,
                schoolType: 'zwl'
            }).then(res => {
                if (res.code > 0) {
                    // this.$toast.clear();
                    this.indexList = res.charArray;
                    this.schoolList = res.schoollist;
                } else {
                    return;
                }
            });
        },
        getSchoolVal() {
            this.schoolList.forEach(val => {
                val.Infos.forEach(el => {
                    if (el.Id == this.schoolVal) {
                        this.schoolName = el.SchoolName;
                    }
                });
            });
        },
        sureSelect() {
            if (this.schoolVal == "") {
                return this.$message.warning('请选择学校');
            }
            if (this.type == 'register') {
                this.$router.push({
                    name: 'phRegister',
                    params: {
                        schoolId: this.schoolVal
                    }
                });
            }
            if (this.type == 'retrieve') {
                this.$router.push({
                    name: 'retrievePassword',
                    params: {
                        schoolId: this.schoolVal
                    }
                });
            }
        }
    }
};
</script>

<style lang="scss">
.h-school-list-wrapper {
    padding-bottom: 40px;

    .van-index-bar__index {
        margin: 5px 0;
    }

    .select-school-group {
        padding: 0 10px;
        background: #fff;
    }

    .school-name-li {
        background: #fff;
    }

    .school-name-val {
        width: calc(100% - 44px);
        padding-left: 1px;
    }

    .select-school-name {
        margin: 13px 0 0 10px;
    }

    .sure-select-btn {
        position: fixed;
        bottom: 0;
        left: 0;
        z-index: 100;
        width: 100%;
        height: 34px;
        line-height: 34px;
        text-align: center;
        font-size: 14px;
        color: #fff;
        background: #3fa2ff;

    }

    .s-search-head-common-wrapper {
        background: #3fa2ff;
        padding: 10px 10px;

        .wl-icon-xiangzuo {
            margin-top: 3px;
            color: #fff;
            font-size: 24px;
        }

        .search-input-con {
            padding: 0;
            background: none !important;
            width: calc(100% - 30px);

            input::-webkit-input-placeholder {
                color: #999;
            }

            .el-icon-search {
                color: #fff;
            }
        }
    }

    .school-name-li-con {
        border-bottom-color: #ECF0F3;
    }

    .school-name-li {
        padding: 10px 15px;
        background: #fff;
    }

    .select-school-radio {
        margin-right: 10px;
        width: 22px;
        height: 22px;
        border-radius: 50%;
        border: 1px solid #ECF0F3;
        box-sizing: border-box;
    }

    .sc-name-val {
        margin-top: 4px;
        width: calc(100% - 60px);
    }

    .activeIndex {
        border: 7px solid #3FA2FF;
    }
}
</style>
